/**
 * Modal Manager
 * Handles global modal dialogs with support for actions
 */

const ModalManager = {
    overlay: null,
    titleEl: null,
    bodyEl: null,
    closeBtn: null,
    actionsContainer: null,

    init() {
        // Create modal DOM if not exists
        if (!document.getElementById('modal-overlay')) {
            this.createModalDOM();
        }

        this.overlay = document.getElementById('modal-overlay');
        this.titleEl = document.getElementById('modal-title');
        this.bodyEl = document.getElementById('modal-body');
        this.closeBtn = document.getElementById('modal-close');
        this.actionsContainer = document.getElementById('modal-actions');

        this.closeBtn.addEventListener('click', () => this.close());

        // Close on click outside (optional)
        this.overlay.addEventListener('click', (e) => {
            if (e.target === this.overlay) {
                this.close();
            }
        });

        console.log('ModalManager initialized');
    },

    createModalDOM() {
        const div = document.createElement('div');
        div.id = 'modal-overlay';
        div.className = 'modal-overlay'; // Ensure CSS exists for this usually in modals.css or main.css
        SafeHTML.set(div, `
            <div class="modal-container">
                <div class="modal-header">
                    <h3 id="modal-title">Título</h3>
                    <button class="btn-icon" id="modal-close"><i class="fas fa-times"></i></button>
                </div>
                <div class="modal-body" id="modal-body">
                    <!-- Content -->
                </div>
                <div class="modal-actions" id="modal-actions">
                    <!-- Buttons -->
                </div>
            </div>
        `);
        document.body.appendChild(div);
    },

    /**
     * Show a modal
     * @param {string} title 
     * @param {string} content HTML content
     * @param {Array} actions Array of objects { text, class, action }
     */
    show(title, content, actions = [], onClose = null) {
        if (!this.overlay) this.init();

        this.onClose?.();
        this.onClose = onClose;

        this.titleEl.textContent = title;
        SafeHTML.set(this.bodyEl, content);
        SafeHTML.set(this.actionsContainer, '');

        if (actions.length > 0) {
            this.actionsContainer.style.display = 'flex';
            actions.forEach(btn => {
                const button = document.createElement('button');
                button.className = `btn ${btn.class || 'btn-secondary'}`;
                // innerHTML (no textContent): algunos botones llevan un icono
                // en btn.text (p.ej. '<i class="fas fa-floppy-disk"></i> Guardar');
                // con textContent ese HTML salía escapado como texto literal.
                SafeHTML.set(button, btn.text);
                button.onclick = btn.action;
                this.actionsContainer.appendChild(button);
            });
        } else {
            this.actionsContainer.style.display = 'none';
        }

        this.overlay.classList.add('active');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
        // The dialog is reused: a new one always opens at the top, not where the last one was left.
        const toTop = () => {
            this.bodyEl.scrollTop = 0;
            const container = this.overlay.querySelector('.modal-container');
            if (container) container.scrollTop = 0;
        };
        toTop();
        if (typeof requestAnimationFrame === 'function') requestAnimationFrame(toTop);
    },

    close() {
        if (!this.overlay) return;
        const cleanup = this.onClose;
        this.onClose = null;
        cleanup?.();
        this.overlay.classList.remove('active');
        document.body.style.overflow = '';
        const modalContainer = this.overlay.querySelector('.modal-container');
        if (modalContainer) {
            modalContainer.classList.remove('contact-directory-modal-container');
        }
        if (this.bodyEl) {
            this.bodyEl.style.padding = '';
            this.bodyEl.style.margin = '';
            this.bodyEl.style.overflow = '';
        }
        if (this.actionsContainer) {
            this.actionsContainer.style.height = '';
            this.actionsContainer.style.padding = '';
            this.actionsContainer.style.margin = '';
            this.actionsContainer.style.border = '';
        }
    },

    showConfirm(message, onConfirm) {
        if (typeof Utils !== 'undefined' && Utils.showConfirm) {
            Utils.showConfirm(message, onConfirm);
        }
    },

    // Alias for compatibility if Utils calls it
    closeModal() {
        this.close();
    }
};

window.ModalManager = ModalManager;
